import React, { useEffect, useState } from 'react';
import { useStandardErrorState } from '../../entities/view-manager/error';
import { BwjViewManager, BwjViewState } from '../../framework/components/bwj-view-manager';
import { CurrentUserService } from '../../app/current-user';
/*@begin-app-target*/import { AttHubAppType } from '../../app-volunteer/app-type';/*@end-app-target*/
import { AuthenticationApiClient } from '../../services/authentication';
import { firstOrDefault } from '../../framework/utils/collection';

interface IStartUpProps {
  onSignInFailure: () => void;
}

export const StartUp: React.FunctionComponent<IStartUpProps> = (props) => {
  const { onSignInFailure } = props;
  const errorView = useStandardErrorState();
  const [viewState, setViewState] = useState(BwjViewState.Loading);

  useEffect(() => {
    const isOversightApp = (AttHubAppType as any) === 'oversight';
    CurrentUserService.initializeService(isOversightApp);
    CurrentUserService.getBearerToken()
    .then(token => {
      if(!token) {
        onSignInFailure();
        setViewState(BwjViewState.Ready);
        return undefined;
      }

      return AuthenticationApiClient.getWebClientVersion();
    })
    .then((resp) => {
      if(resp === undefined) { return resp; }

      const actualVersion = window.document
        .querySelector('meta[name="client-version"]')?.getAttribute('content');
      if(resp.version !== actualVersion) {
        window.location.href = `${window.location.origin}${window.location.pathname}?v=${resp.version}`;
      }

      return CurrentUserService.getBearerToken(); // this will obtain the cached token
    })
    .then(token => {
      if(token === undefined) { return; }
      if(!token) { // handle null token scenario, which "should" never happen
        setViewState(BwjViewState.Error);
        return undefined;
      }

      const domain = firstOrDefault(token.claims.associatedDomains, d => d.id === token.claims.domainId);
      if(!domain) {
        setViewState(BwjViewState.Error);
        return undefined;
      }
      if(domain.eventStart > 0) {
        // TODO: fetch the event
      } else {
        return undefined;
      }
    })
    .then(event => {
      setViewState(BwjViewState.Ready);
      if(event === undefined) { return; }

      // TODO: set event on service
      // TODO: set page title (dom manipulation) and header title via callback prop...
      // TODO: ...on second thought, make the event service do these things.  They need to happen on context changes too
    })
    .catch(() => {
      setViewState(BwjViewState.Error);
    });
  }, [onSignInFailure]);

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: 'One moment please...'
      }}
      errorState={errorView}
    >
      {props.children}
    </BwjViewManager>
  );
};
